import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { normalizeNameOfPerson } from '../../../../../../utils/normalize/normalizeNameOfPerson';
import { phoneNumberTools } from '../../../../../../utils/tools/phoneNumberTools';



const EmergencyContactInfo = props => {
    const {
        emergencyContactInfo: {
            name,
            name: {
                firstName,
                lastName
            },
            phone: {
                phoneNumber
            },
            emailAddress
        },
        pcpIndex
    } = props;

    return (
        <Fragment>
            {
                (firstName && lastName) &&

                <SummaryItem
                    textCode = 'ssap.final_review.emergency_contact_name'
                    value = { normalizeNameOfPerson(name) }
                    ignoreIntl
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].emergencyContactInfo.name`,
                                normalizeNameOfPerson
                            ]
                        ]
                    }
                />
            }
            {
                phoneNumber &&

                <SummaryItem
                    textCode = 'ssap.final_review.emergency_contact_phone_home'
                    value = { phoneNumberTools.getAdjustedPhoneNumber(phoneNumber) }
                    ignoreIntl
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].emergencyContactInfo.phone.phoneNumber`,
                                phoneNumberTools.getAdjustedPhoneNumber
                            ]
                        ]
                    }
                />
            }
            {
                emailAddress &&

                <SummaryItem
                    textCode = 'ssap.final_review.emergency_contact_email_address'
                    value = { emailAddress }
                    ignoreIntl
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ pcpIndex }].emergencyContactInfo.emailAddress`
                            ]
                        ]
                    }
                />
            }
        </Fragment>
    );
};

export default EmergencyContactInfo;